/** Compare string arrays in order (for example SKU chip lists). */
export function orderedStringArraysEqual(left: readonly string[], right: readonly string[]): boolean {
  if (left.length !== right.length) {
    return false;
  }
  for (let index = 0; index < left.length; index += 1) {
    if (left[index] !== right[index]) {
      return false;
    }
  }
  return true;
}

/** Compare string arrays as sets (for example hub user multi-select). */
export function unorderedStringArraysEqual(left: readonly string[], right: readonly string[]): boolean {
  if (left.length !== right.length) {
    return false;
  }
  const sortedLeft = [...left].sort();
  const sortedRight = [...right].sort();
  return orderedStringArraysEqual(sortedLeft, sortedRight);
}
